__turbopack_context__.v({
  "read-more-less": "ReadMoreLess-module__6ptGba__read-more-less",
  "toggle-button": "ReadMoreLess-module__6ptGba__toggle-button",
});
